export default function triggerCalcBtn() {
  function init() {
    function debounce(func, wait = 10, immediate = true) {
      let timeout
      return function() {
        let context = this,
          args = arguments
        let later = function() {
          timeout = null
          if (!immediate) func.apply(context, args)
        }
        let callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
      }
    }

    let scrollpos = window.scrollY
    const header = document.querySelector('.js-calc-btn')
    const header_height = header.offsetHeight + 500

    const add_class_on_scroll = () => header.classList.add('fade-in')
    const remove_class_on_scroll = () => header.classList.remove('fade-in')

    if (document.body.classList.contains('home')) {
      window.addEventListener(
        'scroll',
        debounce(function() {
          scrollpos = window.scrollY

          if (scrollpos >= header_height) {
            add_class_on_scroll()
          } else {
            remove_class_on_scroll()
          }
        }),
      )
    } else {
      header.classList.add('fade-in')
    }
  }

  const isPresent = document.getElementsByClassName('c-sticky-calc-btn')
  if (isPresent.length > 0) {
    init()
  }
}
